module.exports = __webpack_public_path__ + "static/media/bp1.1cea762d.jpg";